import * as React from 'react'

export default props => (
  <svg
    width={24}
    height={25}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 5.995c-3.33-.33-6.68-.5-10.02-.5-1.98 0-3.96.1-5.94.3l-2.04.2M8.5 4.984l.22-1.314c.16-.952.28-1.664 1.97-1.664h2.62c1.69 0 1.82.752 1.97 1.674l.22 1.304M18.85 9.164 18.2 19.26c-.11 1.574-.2 2.798-2.99 2.798H8.79c-2.79 0-2.88-1.224-2.99-2.798L5.15 9.164M10.33 16.543h3.33M9.5 12.533h5"
      stroke="#011533"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
